export const employeesStrings = {
  en: {
    empId: 'Employee ID',
    employees: 'Employees',
    employee: 'Employee',
    addEmployees: 'Add Employee',
    editEmployees: 'Edit Employee',
    updateEmployees: 'Update Employee',
    lastDateHeader: 'Set Last Date of Employee',
    selectEndDatePlace: 'Select End Date',
    employeeWorkDetailHeader: 'Employee Work Detail Form',
    dateOfBirth: 'Date of birth',
    bloodGroup: 'Blood Group',
    skypeContact: 'Skype Contact',
    currentAddress: 'Current Address',
    email: 'Email',
    dailyHour: 'Daily Hours',
    enterNumberPlaceHolder: 'Please enter a valid number',
    tentativeReleaseDate: 'Tentative Release Date',
    fromDate: 'From Date',
    toDate: 'To Date',
    appliedAt: 'Applied On',
    contactNo1: 'Contact No-1',
    contactNo2: 'Contact No-2',
    joiningDate: 'Joining Date',
    action: 'Action',
    gender: 'Gender',
    select: 'Select',
    skill: 'Skill',
    designation: 'Designation',
    contactNo: 'Contact No',
    resignationDate: 'Resignation Date',
    projectManager: 'Project Manager',
    contractor: 'Contractor',
    onRoll: 'on Roll',
    access: 'Access',
    taskTitle: 'Task Title',
    type: 'Type',
    region: 'Region',
    engagementModel: 'Engagement Model',
    reportingManager: 'Reporting Manager',
    projectStartDate: 'Project Start Date',
    deliveryManager: 'Delivery Manager',
    techLead: 'Tech. Lead',
    qaLead: 'QA Lead',
    profileImage: 'Profile Image',
    addEmployeeSuccess: 'Employee Added Successfully!',
    lastDateSuccess: 'Last date added Successfully!',
    editEmployeeSuccess: 'Employee Updated Successfully!',
    workDetail: 'Work Details',
    employeeId: 'Employee Id',
    employeeName: 'Employee Name',
    contact: 'Contact',
    fill30Days:
      'Do you want the Employee to fill the timesheet  for the past 30 days?',
    projectTitle: 'Project Title',
    sittingFloor: 'Sitting Floor',
    forgetID: 'Forget ID Card',
    selectDate: 'Select Date',
    tempIDno: 'Temp. Id Card No.',
    empAllocation: 'Resource Allocation',
    empAllocationOldUI: 'Resource Allocation Old UI',
    previousExperienceInMonths: 'Previous Experience In Months',
    totalExperienceInMonths: 'Total Experience in Months',
    allocationType: 'Allocation Type',
    primarySkill: 'Primary Skills',
    secondarySkills: 'Secondary Skills',
    employeeSkillsSectionTitle: 'Skills',
    employeeSkillsSectionSubtitle: 'Add multiple primary and secondary skills.',
    addSkillButton: '+ Add Skill',
    addSkillModalTitle: 'Add skill',
    addSkillModalSubtitle:
      'Tag this person with a capability and proficiency level.',
    skillTypeLabel: 'Type',
    skillTypePrimary: 'Primary',
    skillTypeSecondary: 'Secondary',
    skillCategoryLabel: 'Category',
    skillLabel: 'Skill',
    proficiencyLabel: 'Proficiency',
    skillTableActions: 'Actions',
    selectSkillCategory: 'Select category',
    selectSkill: 'Select skill',
    pickCategoryFirst: 'Pick category first',
    noSkillsAddedYet: 'No skills added yet. Click Add Skill to begin.',
    employeeSkillsRequired: 'Please add at least one skill.',
    primarySkillRequired: 'Please add at least one primary skill.',
    duplicateEmployeeSkill: 'This skill has already been added.',
    fullStackClassificationTitle: 'Full Stack Classification',
    fullStackDeveloperLabel: 'Full Stack Developer',
    fullStackCategoriesLabel: 'Full Stack Categories',
    selectFullStackCategories: 'Select full stack categories',
    seniority: 'Seniority',
    primarySkillConflictError:
      'Primary skill cannot be selected as secondary skill',
    secondarySkillConflictError:
      'Secondary skill cannot be the same as primary skill',
    duplicateSecondarySkillsError:
      'Duplicate skills are not allowed in secondary skills',
    allocation: 'Allocation',
    projectPhase: 'Project Phase',
    billingType: 'Billing Type',
    billable: 'Billable',
    resourceAllocationOverview: 'Resource Allocation Overview',
    resourceProjectAllocation: 'Resource Project Allocation',
    totalEmployees: 'Total Employees',
    bench: 'Bench',
    underutilized: 'Underutilized',
    optimal: 'Optimal',
    highLoad: 'High Load',
    overallocated: 'Overallocated',
    moreFilters: 'More Filters',
    lessFilters: 'Less Filters',
    reset: 'Reset',
    allocatedHours: 'Allocated Hours',
    allocatedPercent: 'Allocated %',
    allocatedBand: 'Allocated Band',
    allocationStatus: 'Allocation Status',
    dateRange: 'Date Range',
    allocatedBandFilter: 'Allocated Band',
    distributionOnPage: 'Distribution on this page',
    searchFilters: 'Search',
    searchPlaceholder: 'Search by employee or project...',
    next10Days: 'Next 10 Days',
    next30Days: 'Next 30 Days',
    next60Days: 'Next 60 Days',
    next90Days: 'Next 90 Days',
    customRange: 'Custom Range',
    apply: 'Apply',
    all: 'All',
    selectProjects: 'Select Projects',
    selectManagers: 'Select Managers',
    selectTypes: 'Select Types',
    selectCategories: 'Select Categories',
    selectEmployees: 'Select Employees',
    selectPrimarySkills: 'Select Primary Skills',
    selectSecondarySkills: 'Select Secondary Skills',
    selectSeniority: 'Select Seniority',
    selectAllocationStatus: 'Select Allocation Status',
    selectBillingType: 'Select Billing Type',
    selectAllocationBand: 'Select Allocation Band',
    selectDateRange: 'Select Date Range',
    noResourcesForSelectedCriteria: 'No Resources Found for Selected Criteria',
    employeesHeatMap: 'Employee Heat Map',
    heatMapEmployeesWithSkills: 'Employees with skills',
    heatMapSkills: 'Skills',
    heatMapProficiencyLevels: 'Proficiency levels',
    heatMapSkillSearchLabel: 'Skill search',
    heatMapSkillType: 'Skill type',
    heatMapSkillTypeAll: 'All',
    heatMapSkillTypePrimary: 'Primary',
    heatMapSkillTypeSecondary: 'Secondary',
    heatMapCategory: 'Category',
    heatMapCategoryAll: 'All categories',
    heatMapSearchPlaceholder: 'Search skills or categories',
    heatMapEmployeesColumn: 'Employees',
    heatMapNoSkills: 'No skills match your filters',
    heatMapEmployeeListTitle: 'Employees',
    heatMapSeniority: 'Seniority',
    heatMapLegendEmployeeCount: 'Employee count',
    heatMapLegendLow: 'Low',
    heatMapLegendHigh: 'High',
    heatMapSummary: '{skillCount} skills • {employeeCount} employees',
    heatMapProficiencyColumn: '{level}/5'
  },
  es: {}
}
